// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__-MDEL","wrapper":"Icon_wrapper__YUCpV"};